export default [
  {
    target: '.filters-container .icon-container',
    key: 'transportModeDisplay',
    direction: 'right',
  },
  {
    target: '.aside-sizer .aside-nav .entry-bus',
    key: 'transportModeAside',
    direction: 'right',
  },
  {
    target: '.aside-sizer .aside-nav .entry-pin',
    key: 'targetSitesAside',
    direction: 'right',
  },
  {
    target: '.aside-sizer .aside-nav .entry-people',
    key: 'filtersAside',
    direction: 'right',
  },
  {
    target: '.aside-sizer .aside-nav .entry-rank',
    key: 'heatmapAside',
    direction: 'right',
  },
  {
    target: '.menu-helper .casual-nav',
    key: 'menuHelper',
    direction: 'bottom',
  },
  {
    target: '.menu-helper .map-cta',
    key: 'mapHelper',
    direction: 'bottom',
  },
  {
    target: '.header-main .ui-helper .nav-cta',
    key: 'exportHelper',
    direction: 'bottom',
  },
  {
    target: '.header-main .ui-helper .nav-cta.user-button',
    key: 'seeAgain',
    direction: 'bottom-left',
  },
];
